export default "__VITE_ASSET__57d97072__"